import * as React from 'react'

// Utils
import * as utils from 'Utils'

const getParsedValue = (value) => {
  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}

const getParamsFromURL = (location) => {
  const params = new URLSearchParams(location?.search).entries()

  return Array.from(params).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: getParsedValue(value),
    }
  }, {})
}

export const useQueryParams = (location, history) => {
  const [queryParams, setQueryParams] = React.useState(getParamsFromURL(location))

  const getParams = () => {
    return queryParams
  }

  const appendParams = (params) => {
    if (window.history.pushState && location) {
      const searchParams = new URLSearchParams(location.search)
      Object.entries(params).forEach(([key, value]) => {
        searchParams.delete(key)
        searchParams.set(key, JSON.stringify(value))
      })
      const newURL =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        `?${searchParams.toString()}`
      window.history.pushState({ path: newURL }, '', newURL)
    }
  }

  const setParams = (params, replaceRoute, mergeFilters = true) => {
    const currentParams = getParams()
    if (currentParams.filterType) {
      params.filterType = currentParams.filterType
    }
    const paramsToSet = mergeFilters ? { ...currentParams, ...params } : params
    utils.setFilterQueryParams(paramsToSet, location.pathname, history, replaceRoute)
  }

  React.useEffect(() => {
    const params = getParamsFromURL(location)
    setQueryParams(params)
  }, [location])

  return { appendParams, getParams, setParams }
}
